/**
 * Chip "Nuevo" del toggle Match: se muestra hasta que el viajero abre la pestaña Match
 * o hasta el 15/dic/2026, lo que ocurra primero. `localStorage` es solo una comodidad:
 * si no está disponible, el chip se ve hasta la fecha de caducidad.
 */
const SEEN_KEY = 'guvery_match_new_seen';
const NEW_UNTIL = new Date(2026, 11, 15);

export const isMatchNewVisible = (): boolean => {
  if (new Date() >= NEW_UNTIL) return false;
  try {
    return localStorage.getItem(SEEN_KEY) !== '1';
  } catch (e) {
    return true;
  }
};

export const markMatchSeen = (): void => {
  try {
    localStorage.setItem(SEEN_KEY, '1');
  } catch (e) {
    // noop: modo privado o almacenamiento bloqueado
  }
};
